import { getImageVersion } from "@/lib/imageVersion";

// ============================================================
// Zentrales Bilderverzeichnis
// ------------------------------------------------------------
// Alle Bilder liegen im Supabase-Bucket "site-images" in einer
// sauberen Ordnerstruktur:
//
//   home/                Startseite (Hero-Slider + Inhaltsbilder)
//   about/               Über uns (Gastgeber, Erinnerungen, Logo)
//   activities/          Touren & Aktivitäten:
//     day-trips/         Tagestouren (Slider + Header + Karten)
//     multi-day-tours/   Rundreisen (Slider + Header + Karten)
//     adventure-tours/   Abenteuer (Tauchen, Rafting, Segeln)
//     maps-tour-routes/  Tour-Routenkarten
//     shopping-bali/     Shopping in Bali
//     health-sports/     Gesundheit & Sport
//     booking/            Buchungsseiten-Header
//     tour-info/         Tour-Infos + Galerie
//   villas/              Villen (Galerie, villa-*, Header)
//   weddings/            Hochzeit (Header + Galerie)
//   bali-info/           Bali-Informationen
//   contact/             Kontakt-Header
//   legal-pages/         Header der Rechtsseiten (Impressum, Datenschutz)
//
// Ein Bild austauschen = neue Datei mit demselben Namen
// hochladen. Der Bildpfad im Code bleibt unverändert.
//
// HINWEIS – Cache: An jede Adresse wird automatisch ein Versions-Häkchen
// (?v=…) gehängt. Diese Version kommt aus getImageVersion() und wird beim
// Laden automatisch mit dem echten Änderungszeitpunkt der Bilder aus
// Supabase abgeglichen (siehe @/lib/imageVersion). Dadurch erscheint ein
// ausgetauschtes Bild von selbst – ganz ohne Code-Änderung.
// ============================================================

const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;

export const IMG_BASE = `${SUPABASE_URL}/storage/v1/object/public/site-images`;

// Supabase kann Bilder bei der Auslieferung automatisch verkleinern.
// So entsteht aus EINER Datei eine kleine Raster-Version, ganz ohne
// zweites Upload.
export const IMG_RENDER_BASE = `${SUPABASE_URL}/storage/v1/render/image/public/site-images`;

// Manueller Stempel: Wird dieser Wert geändert, laden ALLE Bilder einmal
// komplett neu (Browser/CDN-Cache wird umgangen). Nötig, wenn ein Foto im
// Speicher ersetzt wurde und der Browser trotzdem noch das alte zeigt.
const IMAGE_CACHE_STAMP = "2026-10-28-1";

/** Liefert die vollständige URL zu einem Bildpfad innerhalb des Buckets. */
export const img = (path: string) =>
  `${IMG_BASE}/${path}?v=${getImageVersion()}&s=${IMAGE_CACHE_STAMP}`;

/**
 * Verkleinerte Raster-Version eines Bildes (z. B. für Galerie-Kacheln).
 * Supabase erzeugt sie automatisch aus dem Original – es ist keine
 * separate `_thumb`-Datei nötig.
 */
export const thumbImg = (path: string, width = 800) =>
  `${IMG_RENDER_BASE}/${path}?width=${width}&quality=80&resize=contain&v=${getImageVersion()}&s=${IMAGE_CACHE_STAMP}`;